export default __webpack_public_path__ + "static/media/ivanti.df023f48.png";